/**
 * Add Bots Section
 * Launches the teacher add-bots sheet while preserving the current seat-cap rules.
 */

import { Text, Pressable } from 'react-native'
import { teacherControlStyles as styles } from './styles'

export interface AddBotsSectionProps {
  availableSeats: number
  isAddingDuringGame: boolean
  onOpen: () => void
}

export function AddBotsSection({ availableSeats, isAddingDuringGame, onOpen }: AddBotsSectionProps) {
  return (
    <Pressable onPress={onOpen} style={({ pressed }) => [styles.button, styles.addBotsButton, pressed && { opacity: 0.7 }]}>
      <Text style={styles.buttonText}>
        Add Bots ({availableSeats} seats){isAddingDuringGame ? '*' : ''}
      </Text>
    </Pressable>
  )
}
